import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInbox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M139.16 57.859L139.123 57.7112L118.389 5.0264C117.465 2.05121 114.711 0 111.588 0H27.544C24.4025 0 21.6121 2.08817 20.7251 5.10032L1.34017 57.2492L1.28474 57.3786L1.24778 57.5264C1.00755 58.4319 0.933628 59.3559 1.06298 60.2614C1.0445 60.557 1.02603 60.8527 1.02603 61.1484V128.765C1.03091 131.743 2.21622 134.598 4.32222 136.704C6.42822 138.81 9.28317 139.995 12.2615 140H128.164C134.355 140 139.4 134.955 139.418 128.765V61.1484C139.418 60.9081 139.418 60.6679 139.4 60.4646C139.474 59.5591 139.4 58.6906 139.16 57.859ZM84.4975 49.9129L84.4421 52.8142C84.2942 61.1114 78.5656 66.6922 70.1945 66.6922C66.1105 66.6922 62.5994 65.3801 60.0677 62.8854C57.5361 60.3907 56.1501 56.9166 56.0762 52.8142L56.0207 49.9129H17.9901L32.6813 14.1922H106.451L121.549 49.9129H84.4975ZM15.1997 64.1051H44.2678C48.7583 74.6568 58.3122 80.8844 70.2129 80.8844C76.4405 80.8844 82.2246 79.1473 86.8998 75.858C91.0023 72.9752 94.1992 68.9467 96.2689 64.1051H125.189V125.808H15.1997V64.1051Z",
		fill: "#26292E"
	})
});
export default SvgInbox;
